import { useFormats } from "@portal/hooks/use-formats";
import { GrowCurrencyText } from "@sinecycle/growcomponents";
import { Flex } from "../Flex/Flex";
import { TypographyText } from "../Typography/AntTypography";
import { MultiCurrencyProps } from "./types";
const t = {
  invoices: "Invoices",
};
function CurrencyList(props: MultiCurrencyProps["multiCurrencySplit"][number]) {
  const {
    value,
    currency,
    value_in_transformed_currency,
    transformed_currency,
    invoice_count,
  } = props;

  const { locale } = useFormats();

  const CurrencyName = <TypographyText fs="12">{currency}</TypographyText>;
  const CurrencyAmount = (
    <GrowCurrencyText
      amount={value}
      options={{
        currency,
        locale,
      }}
      textProps={{ strong: true }}
    />
  );

  const BaseCurrency = (
    <TypographyText fs="14" style={{ color: "var(--primary-10)" }}>
      {transformed_currency !== currency && (
        <GrowCurrencyText
          amount={value_in_transformed_currency}
          options={{
            currency: transformed_currency ?? "USD",
            locale,
          }}
          textProps={{ strong: true }}
        />
      )}
    </TypographyText>
  );
  const InvoiceCount = invoice_count ? (
    <TypographyText
      fs="12"
      style={{ color: "var(--gray-8)" }}
    >{`${t.invoices} ${invoice_count}`}</TypographyText>
  ) : null;

  const AmountArea = (
    <Flex vertical align="start" style={{ gap: "0", width: "100%" }}>
      {CurrencyName}
      <Flex align="center" justify="space-between" style={{ width: "100%" }}>
        {CurrencyAmount}
        {BaseCurrency}
      </Flex>
      {InvoiceCount}
    </Flex>
  );
  return <>{AmountArea}</>;
}

export { CurrencyList };
